
import { Component, Vue, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { TGuide } from "@/models/guide";
import { SMUser } from "@/store";

const TABS = [
  {
    title: "Get a Skilled Worker visa",
    img: "bulb-outline",
  },
  {
    title: "Arrival to the UK",
    img: "rocket-outline",
  },
];

@Component({
  components: {
    GuideCard: () => import("./components/GuideCard.vue"),
    ComplianceExpiredWidget: () => import("@/modules/Compliance/ComplianceExpiredWidget.vue"),
  },
})
export default class Browse extends Vue {
  activeTab = 1;
  allCards: TGuide[] = [] as TGuide[];
  cards: TGuide[] = [] as TGuide[];

  get tabs() {
    if (SMUser.isEmployee) return TABS;

    return [];
  }

  @Watch("tabs")
  tabsChanged(val) {
    if (!val) return;

    this.cards = this.allCards.filter(
      (item: TGuide) => item.tab_name === this.activeTab.toString()
    );
  }

  getTabClasses(index: number) {
    return this.activeTab !== index + 1 ? "inactive-tab" : "";
  }

  get cardsClasses() {
    if (!this.tabs?.length) return "right-radius left-radius";

    if (this.activeTab === 1) return "right-radius";
    if (this.activeTab === 2) return "left-radius";

    return "right-radius left-radius";
  }

  @Watch("activeTab")
  tabChanged(tab: number) {
    this.cards = this.allCards.filter((item: TGuide) => item.tab_name === tab.toString());
  }

  selectTab(index: number) {
    this.activeTab = index + 1;
  }

  mounted() {
    this.fetchCards();
  }

  get isComplianceBlocked() {
    return SMUser.user?.is_compliance_blocked;
  }

  get showExpiredWidget() {
    return this.isComplianceBlocked && !SMUser.isCandidate;
  }

  openGuideDisabled(subscribe: boolean) {
    if (!subscribe) return false;

    return this.isComplianceBlocked && !SMUser.isCandidate;
  }

  get expiredWidgetDescription() {
    if (SMUser.isEmployer) return this.$tc("widget.expired.description.employer");

    if (SMUser.isEmployee || SMUser.isCandidate) {
      return this.$tc("widget.expired.description.employee");
    }

    return "";
  }

  async fetchCards() {
    const { data } = await this.axios.get(API_ROUTES.GUIDES);

    this.allCards = data;

    this.$nextTick(() => {
      if (!this.tabs.length) return (this.cards = data);

      this.cards = data.filter((item: TGuide) => item.tab_name === this.activeTab.toString());
    });
  }
}
